import React from 'react';
import * as styles from './branding-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BrandingHeader = _ref => {
  var _ref$agency = _ref.agency,
    logoBackgroundColour = _ref$agency.logoBackgroundColour,
    name = _ref$agency.name,
    images = _ref$agency.images,
    profileUrl = _ref$agency.profileUrl;
  return ___EmotionJSX(React.Fragment, null, profileUrl && (images === null || images === void 0 ? void 0 : images.logo) && ___EmotionJSX("a", {
    css: styles.banner(logoBackgroundColour),
    href: profileUrl
  }, ___EmotionJSX("img", {
    css: styles.bannerLogo,
    src: images.logo,
    alt: name
  })), !profileUrl && ___EmotionJSX("div", {
    css: styles.banner(logoBackgroundColour)
  }, ___EmotionJSX("img", {
    css: styles.bannerLogo,
    src: images.logo,
    alt: name
  })));
};